<div class="wrapper">
  <app-layout-default-header *ngIf="!isLogged"></app-layout-default-header>
  <app-layout-manager-header *ngIf="isLogged"></app-layout-manager-header>
  <router-outlet></router-outlet>
  <app-layout-manager-footer></app-layout-manager-footer>
</div>
